import { library } from '@fortawesome/fontawesome-svg-core';
import { faTwitter, faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faTwitter, faInstagram, faFacebook);

export { FontAwesomeIcon };
